import { render, staticRenderFns } from "./UpdateActions.vue?vue&type=template&id=b47fda4e&scoped=true&"
import script from "./UpdateActions.vue?vue&type=script&lang=js&"
export * from "./UpdateActions.vue?vue&type=script&lang=js&"
import style0 from "./UpdateActions.vue?vue&type=style&index=0&id=b47fda4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47fda4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b47fda4e')) {
      api.createRecord('b47fda4e', component.options)
    } else {
      api.reload('b47fda4e', component.options)
    }
    module.hot.accept("./UpdateActions.vue?vue&type=template&id=b47fda4e&scoped=true&", function () {
      api.rerender('b47fda4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/conversationBulkActions/UpdateActions.vue"
export default component.exports